(function () {
  'use strict';

  var root = document.querySelector('[data-help-center]');
  if (!root) return;

  var baseUrl = root.getAttribute('data-base-url') || window.location.pathname;
  var searchResultsLabel = root.getAttribute('data-search-results-label') || 'Arama Sonuçları';

  var homeView = root.querySelector('[data-hc-view="home"]');
  var listView = root.querySelector('[data-hc-view="list"]');
  var heroHeading = root.querySelector('.help-center__heading');
  var breadcrumb = root.querySelector('[data-hc-breadcrumb]');
  var breadcrumbCurrent = root.querySelector('[data-hc-breadcrumb-current]');
  var homeLink = root.querySelector('[data-hc-home-link]');
  var listTitle = root.querySelector('[data-hc-list-title]');
  var listDescription = root.querySelector('[data-hc-list-description]');
  var articleList = root.querySelector('[data-hc-article-list]');
  var emptyState = root.querySelector('[data-hc-empty]');
  var searchWrapper = root.querySelector('[data-hc-search]');
  var searchInput = root.querySelector('[data-hc-search-input]');
  var searchClear = root.querySelector('[data-hc-search-clear]');
  var searchStatus = root.querySelector('[data-hc-search-status]');

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-hc-card]'));
  var articles = Array.prototype.slice.call(root.querySelectorAll('[data-hc-article]'));
  var navLinks = Array.prototype.slice.call(root.querySelectorAll('[data-hc-nav-link]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-hc-chip]'));

  if (!homeView || !listView || !articleList) return;

  function normalize(value) {
    return (value || '').toLocaleLowerCase('tr-TR').trim();
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function getTriggers() {
    return Array.prototype.slice.call(articleList.querySelectorAll('[data-hc-trigger]')).filter(function (trigger) {
      return !trigger.closest('[data-hc-article]').hidden;
    });
  }

  function toggleItem(trigger) {
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    trigger.setAttribute('aria-expanded', String(!expanded));
    if (panel) panel.hidden = expanded;
  }

  articleList.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-hc-trigger]');
    if (trigger) toggleItem(trigger);
  });

  articleList.addEventListener('keydown', function (event) {
    var trigger = event.target.closest('[data-hc-trigger]');
    if (!trigger) return;

    var triggers = getTriggers();
    var index = triggers.indexOf(trigger);
    if (index === -1) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      triggers[(index + 1) % triggers.length].focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      triggers[(index - 1 + triggers.length) % triggers.length].focus();
    } else if (event.key === 'Home') {
      event.preventDefault();
      triggers[0].focus();
    } else if (event.key === 'End') {
      event.preventDefault();
      triggers[triggers.length - 1].focus();
    }
  });

  var currentView = null;

  function scrollHeadingIntoView(target) {
    if (!target) return;
    target.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  function setView(view, opts) {
    var isList = view === 'list';
    var changed = currentView !== view;
    homeView.hidden = isList;
    listView.hidden = !isList;
    if (breadcrumb) breadcrumb.hidden = !isList;
    currentView = view;
    if (changed && !(opts && opts.silent)) {
      scrollHeadingIntoView(isList ? listTitle : heroHeading);
    }
  }

  function updateEmptyState() {
    var visibleCount = articles.filter(function (item) {
      return !item.hidden;
    }).length;
    if (emptyState) emptyState.hidden = visibleCount !== 0;
    articleList.hidden = visibleCount === 0;
    return visibleCount;
  }

  function setActiveNav(handle) {
    navLinks.forEach(function (link) {
      var isActive = link.getAttribute('data-category-handle') === handle;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function findCard(handle) {
    return cards.filter(function (card) {
      return card.getAttribute('data-category-handle') === handle;
    })[0];
  }

  function renderCategory(handle, opts) {
    var card = findCard(handle);
    if (!card) {
      setView('home', opts);
      return;
    }

    var name = card.getAttribute('data-category-name');
    var description = card.getAttribute('data-category-description');

    articleList.classList.remove('is-search-mode');
    articles.forEach(function (item) {
      item.hidden = item.getAttribute('data-category-handle') !== handle;
    });

    if (listTitle) listTitle.textContent = name;
    if (listDescription) {
      listDescription.textContent = description || '';
      listDescription.hidden = !description;
    }
    if (breadcrumbCurrent) breadcrumbCurrent.textContent = name;

    setActiveNav(handle);
    updateEmptyState();
    setView('list', opts);
  }

  function renderSearch(query) {
    var queryTokens = normalize(query).split(/\s+/).filter(Boolean);
    articleList.classList.add('is-search-mode');

    articles.forEach(function (item) {
      var haystack = normalize(item.getAttribute('data-question')) + ' ' +
        normalize(item.getAttribute('data-answer')) + ' ' +
        normalize(item.getAttribute('data-keywords'));
      item.hidden = !queryTokens.every(function (token) {
        return haystack.indexOf(token) !== -1;
      });
    });

    if (listTitle) listTitle.textContent = searchResultsLabel;
    if (listDescription) listDescription.hidden = true;
    if (breadcrumbCurrent) breadcrumbCurrent.textContent = searchResultsLabel;

    setActiveNav(null);
    var visibleCount = updateEmptyState();
    setView('list');

    if (searchStatus) {
      searchStatus.textContent = visibleCount + ' sonuç bulundu';
    }
  }

  function getCategoryFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('category');
  }

  function clearSearchInput() {
    if (!searchInput) return;
    searchInput.value = '';
    if (searchWrapper) searchWrapper.classList.remove('hc-search--has-value');
  }

  function showViewFromUrl(opts) {
    var handle = getCategoryFromUrl();
    if (handle) {
      renderCategory(handle, opts);
    } else {
      setView('home', opts);
    }
  }

  function goToCategory(handle) {
    var url = new URL(baseUrl, window.location.origin);
    url.searchParams.set('category', handle);
    window.history.pushState({ category: handle }, '', url.toString());
    clearSearchInput();
    renderCategory(handle);
  }

  function goHome() {
    window.history.pushState({}, '', baseUrl);
    clearSearchInput();
    setView('home');
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function (event) {
      event.preventDefault();
      goToCategory(card.getAttribute('data-category-handle'));
    });
  });

  if (homeLink) {
    homeLink.addEventListener('click', function (event) {
      event.preventDefault();
      goHome();
    });
  }

  window.addEventListener('popstate', function () {
    clearSearchInput();
    showViewFromUrl();
  });

  if (searchInput) {
    var handleSearch = debounce(function () {
      var value = searchInput.value;
      if (searchWrapper) searchWrapper.classList.toggle('hc-search--has-value', value.length > 0);

      if (value.trim() === '') {
        showViewFromUrl();
        return;
      }

      renderSearch(value);
    }, 180);

    searchInput.addEventListener('input', handleSearch);
  }

  if (searchClear) {
    searchClear.addEventListener('click', function () {
      clearSearchInput();
      searchInput.focus();
      showViewFromUrl();
    });
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      if (!searchInput) return;
      searchInput.value = chip.getAttribute('data-query') || '';
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      searchInput.focus();
    });
  });

  showViewFromUrl({ silent: true });
})();
